"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var i18next_browser_languagedetector_1 = require("i18next-browser-languagedetector");
var changeLanguage_1 = require("./changeLanguage");
var types_1 = require("./types");
function i18nAppProvider(i18nextInstance) {
    return {
        initialize: function (options) {
            var _a;
            var englishStrings = options.englishStrings, rest = __rest(options, ["englishStrings"]);
            var resources = Object.keys(rest).reduce(function (p, k) {
                var _a;
                return (__assign({}, p, (_a = {}, _a[types_1.LanguageInitMap[k]] = {
                    translation: options[k],
                }, _a)));
            }, {});
            i18nextInstance
                // detect user language
                // https://github.com/i18next/i18next-browser-languageDetector
                .use(i18next_browser_languagedetector_1.default);
            // https://www.i18next.com/overview/configuration-options
            i18nextInstance.init({
                resources: __assign((_a = {}, _a[types_1.SupportedLanguages.EN] = {
                    translation: englishStrings,
                }, _a), resources),
                fallbackLng: types_1.SupportedLanguages.EN,
                debug: false,
                detection: {
                    // order and from where user language should be detected
                    order: ['querystring', 'cookie', 'localStorage', 'navigator'],
                    // keys or params to lookup language from
                    lookupQuerystring: 'intl',
                    lookupLocalStorage: 'i18nextLng',
                    lookupCookie: 'dd_language',
                    lookupFromPathIndex: 0,
                    lookupFromSubdomainIndex: 0,
                    // cache user language on
                    caches: ['cookie', 'localStorage'],
                    // languages to not persist (cookie, localStorage)
                    excludeCacheFor: ['cimode'],
                },
                interpolation: {
                    escapeValue: false,
                },
            });
        },
        addLanguages: function (languages, resources) {
            languages.map(function (lang) {
                if (resources[lang] && types_1.LanguageInitMap[lang]) {
                    i18nextInstance.addResourceBundle(types_1.LanguageInitMap[lang], 'translation', resources[lang], true, true);
                }
            });
        },
        changeLanguage: function (lang) {
            return changeLanguage_1.default(i18nextInstance, lang).then(function () {
                window.location.reload();
            });
        },
        getCurrentLanguage: function () {
            return i18nextInstance.language;
        },
        translate: function (key, config) {
            return i18nextInstance.t(key, config);
        },
    };
}
exports.default = i18nAppProvider;
